export const SITE_MEASUREMENT_SYSTEM = {
  boma: 0,
  rebny: 1
};

export const SITE_MEASUREMENT_SYSTEM_LABEL = {
  [SITE_MEASUREMENT_SYSTEM.boma]: 'BOMA',
  [SITE_MEASUREMENT_SYSTEM.rebny]: 'REBNY'
};
